<template>
  <div
    v-if="editCouponData"
    class="discount-list-content"
  >
    <div
      v-if="hasPromotion"
      class="bonusWrap"
    >
      <div class="itemTitle">
        <i class="titleIcon icon-promotion-activity" />
        優惠活動
        <template v-if="promotionDiscountAmount">
          <span class="discount-status-box">
            折抵${{ $setPriceFormat(promotionDiscountAmount) }}
          </span>
        </template>
      </div>
      <div class="usingState">
        <div
          v-if="promotionDiscountAmount"
          class="tag active"
        >
          <span>已符合</span>
        </div>
        <div
          v-else
          class="tag disabled"
        >
          <span>未符合活動折抵條件</span>
        </div>
      </div>
    </div>
    <div
      v-if="editCouponData.code.isUse && editCouponData.code.detail.OrderActivityType === 2"
      class="bonusWrap"
    >
      <div class="itemTitle">
        <i class="titleIcon icon-recommended-discount" />
        折扣碼
        <span class="discount-status-box">
          折抵${{ editCouponData.code.detail.DiscountAmount }}
        </span>
      </div>
      <div class="usingState">
        <div
          class="right"
          @click="removeDiscountHandler"
        >
          <i class="icon-delete-circle"><span class="path1" /><span class="path2" /></i>
        </div>
      </div>
    </div>
    <div
      v-if="editCouponData.code.isUse && editCouponData.code.detail.OrderActivityType === 1"
      class="bonusWrap"
    >
      <div class="itemTitle">
        <i class="titleIcon icon-recommended-discount" />
        推薦優惠
        <span class="discount-status-box">
          折抵${{ editCouponData.code.detail.DiscountAmount }}
        </span>
      </div>
      <div class="usingState">
        <div
          class="right"
          @click="removeDiscountHandler"
        >
          <i class="icon-delete-circle"><span class="path1" /><span class="path2" /></i>
        </div>
      </div>
    </div>
    <div class="bonusWrap">
      <div class="itemTitle">
        <i class="titleIcon icon-single-coupon" />
        優惠券
        <span
          v-if="ticketAmount > 0"
          class="discount-status-box"
        >
          折抵${{ ticketAmount }}
        </span>
      </div>
      <div class="usingState">
        <template v-if="ticketAmount > 0">
          <div
            class="right"
            @click="removeTicketHandler"
          >
            <i class="icon-delete-circle"><span class="path1" /><span class="path2" /></i>
          </div>
        </template>
        <template v-else>
          <div
            class="select-btn"
            @click="$emit('openSelectTicket')"
          >
            <span>選擇優惠券</span>
            <i class="icon-chevron-right" />
          </div>
        </template>
      </div>
    </div>
    <div
      class="bonusWrap"
      :class="{'alignItemCenter-reset': enterpriseCoinDiscountAvailable}"
    >
      <div class="itemTitle">
        <i class="titleIcon icon-spoint-l" />
        <div>
          <div class="textWrap">
            紅利折抵
            <span class="discount-status-box">
              <span v-if="editCouponData.bonus.isLoading">取得紅利點數中...</span>
              <template v-else-if="editCouponData.bonus.state === 'used' || editCouponData.bonus.state === 'notuse'">
                折抵${{ pointDiscountDisplay }}
              </template>
            </span>
          </div>
          <!-- 企業點數 -->
          <div
            v-if="enterpriseCoinDiscountAvailable"
            class="enterprise-point"
          >
            <span>內含企業夥伴點數{{ editCouponData.bonus.point.CanUseEnterpriseAmount }}點</span>
          </div>
        </div>
      </div>
      <div class="usingState">
        <template v-if="!editCouponData.bonus.isLoading">
          <div
            v-if="editCouponData.bonus.state === 'used' || editCouponData.bonus.state === 'notuse'"
            class="right"
          >
            <v-checkbox
              v-model="editCouponData.bonus.state"
              class="checkbox"
              true-value="used"
              false-value="notuse"
              :hide-details="true"
              @change="selectBonus"
            />
          </div>
          <template v-else-if="editCouponData.bonus.state === 'empty'">
            <span class="disable">尚無紅利可折抵</span>
          </template>
          <template v-else-if="editCouponData.bonus.state === 'disable'">
            <span class="disable">您的點數無法在此服務使用</span>
          </template>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import ticketAndBonus from '@/mixin/ticketAndBonus'
export default {
  name: 'DiscountList',
  mixins: [ticketAndBonus],
  inject: {
    isQuotationMode: {
      from: 'isQuotationMode',
      default: false
    },
    orderId: {
      from: 'orderId',
      default: null
    },
    getQuotationId: {
      from: 'getQuotationId',
      default: null
    }
  },
  props: {
    discountData: Object,
    serviceId: Number,
    serviceTypeId: Number,
    orderAmount: Number,
    hasPromotion: Boolean,
    promotion: Object,
    updateCheck: Object,
    promotionDiscountAmount: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      editCouponData: null
    }
  },
  computed: {
    quotationId () {
      if (typeof this.getQuotationId !== 'function') return null
      return this.getQuotationId()
    },
    ticketAmount () {
      return this.editCouponData.ticket?.discount || 0
    },
    enterpriseCoinAvailable () {
      const enterpriseCoinAvailableServiceTypeId = this.$nuxt.context.env.ENTERPRISE_POINT_AVAILABLE_SERVICE_TYPE_ID
      return enterpriseCoinAvailableServiceTypeId.includes(this.serviceTypeId)
    },
    enterpriseCoinDiscountAvailable () { // 是否能使用&是否有 企業點數折抵
      return (this.enterpriseCoinAvailable && this.editCouponData.bonus.point?.CanUseEnterpriseAmount)
    },
    pointDiscountDisplay () {
      if (!this.editCouponData?.bonus?.point) return 0
      const bonusAmount = this.editCouponData.bonus.point?.CanUseBonusAmount || 0
      const enterpriseAmount = this.editCouponData.bonus.point?.CanUseEnterpriseAmount || 0
      return bonusAmount + enterpriseAmount
    }
  },
  watch: {
    discountData: {
      async handler (newVal) {
        this.editCouponData = _.cloneDeep(newVal)
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    selectBonus () {
      this.$emit('updateDiscountUsage', {
        type: 'bonus',
        data: this.editCouponData.bonus
      })
    },
    removeTicketHandler () {
      this.$emit('updateDiscountUsage', {
        type: 'ticket',
        data: {
          discount: 0,
          TicketInstanceId: null,
          index: null,
          detail: null,
          list: this.editCouponData.ticket.list
        }
      })
    },
    removeDiscountHandler () {
      this.$emit('updateDiscountUsage', {
        type: 'code',
        data: {
          discount: 0,
          detail: null,
          input: '',
          isUse: false,
          isSaving: false,
          errorMessage: ''
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.discount-list-content{
  overflow-x: hidden;
  .bonusWrap{
    background-color: $whiteColor;
    padding: 10px 0 10px 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    &:not(:last-child) {
      border-bottom: 1px dashed #d2d2d2;
    }
    .itemTitle{
      padding: 5px 0;
      line-height: 1.3;
      display: flex;
      align-items: center;
      .titleIcon {
        font-size: 22px;
        color: $mainColor;
        margin-right: 8px;
      }
      .textWrap {
        display: flex;
      }
      .discount-status-box {
        font-size: 15px;
        color: $mainColor;
        margin-left: 8px;
        font-weight: bold;
      }
      .enterprise-point {
        color: #388cbb;
        font-size: 13px;
        margin-top: 4px;
      }
    }
    .usingState{
      display: flex;
      justify-content: space-between;
      align-items: center;
      line-height: 1.3;
      margin-right: 8px;
      .select-btn {
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: #999999;
        cursor: pointer;
        i {
          font-size: 20px;
        }
      }
      .tag {
        display: flex;
        flex: none;
        justify-content: center;
        align-items: center;
        color: #fff;
        border-radius: 2px;
        padding: 2px 8px;
        &.active {
          background-color: $mainColor;
        }
        &.disabled {
          background-color: #999999;
        }
        span {
          font-weight: bold;
          font-size: pxTorem(14px);
          line-height: pxTorem(22px);
        }
      }
      .checkbox {
        margin: 0;
        ::v-deep {
          .v-input--selection-controls__input {
            margin: 0;
          }
        }
      }
      .disable{
        color: #999999;
      }
      .icon-delete-circle {
        cursor: pointer;
        font-size: 22px;
        color: rgba(0, 0, 0, 0.2);
      }
    }
  }
}
</style>
